import React from 'react';

interface OldUrlRedirectWrapperProps {
  children: React.ReactNode;
}

// URL migration feature disabled - this component is now a pass-through
export const OldUrlRedirectWrapper: React.FC<OldUrlRedirectWrapperProps> = ({ children }) => {
  return <>{children}</>;
};
